<template>
  <el-dialog title="流程终止" :visible.sync="endProcessDialog" :close-on-click-modal="false">
    <table cellspacing="0" cellpadding="0" border="0" class="form-table">
      <tbody>
        <tr>
          <th style="width: 100px;">
            <span class="xh-star">*</span>终止原因：
          </th>
          <td colspan="3">
            <OpinionText ref="opinionText"/>
          </td>
        </tr>
        <tr>
          <th style="width: 100px;">附件上传：</th>
          <td colspan="3">
            <FileUpload ref="fileUpload"/>
          </td>
        </tr>
      </tbody>
    </table>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="confirm" size="small">确 定</el-button>
      <el-button @click="cancel" size="small">取 消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapState, mapActions } from "vuex";
import OpinionText from "@/components/common/opinionText.vue";
import FileUpload from "@/components/common/fileUpload.vue";
import { Message } from "element-ui";
import utils from "@/utils.js";

export default {
  name: "taskToEndProcess",
  props: ["taskId"],
  components: { OpinionText, FileUpload },
  data() {
    return {
      endProcessDialog: false,
      token:utils.getUrlKey("token"),
    };
  },
  computed: mapState({
    currentUser: state => state.login.currentUser
  }),
  methods: {
    //鼠标点击页面其他其他位置不关闭弹框
    handleClose(done) {
      this.endProcessDialog = true;
    },
    //取消
    cancel() {
      this.endProcessDialog = false;
    },
    //确认
    confirm() {
      if (this.$refs.opinionText.getOpinion() == "") {
        Message.warning("请填写终止原因");
        return;
      }
      let files = "";
      if (this.$refs.fileUpload.getFiles() != "") {
        files = JSON.stringify(this.$refs.fileUpload.getFiles());
      }
      this.$store.dispatch("login/validAndCompletedCurrent").then(() => {
        let data = {
          taskId: this.taskId,
          endReason: this.$refs.opinionText.getOpinion(),
          messageType: "inner",
          account: this.currentUser.account,
          files: files
        };
        this.$store.dispatch("storeProcess/doEndProcess", data).then(() => {
          this.endProcessDialog = false;
          // if(this.token!=null){
            if(window.ch){
              //浏览器的两个选项卡之间通讯 新窗口发送消息
              window.ch.postMessage("some data");
            }
            window.close();
          // }else{
          //   this.$router.go(-1);
          // }
        });
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
.el-dialog__footer {
  padding: 10px 20px;
  padding-top: 10px;
  text-align: right;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.form-table {
  width: 100%;
  border-top: 1px solid #ebeef5;
  border-left: 1px solid #ebeef5;
}

.form-table th {
  text-align: right;
  color: #666;
}

.form-table th > span {
  color: #f00;
}

.form-table th, .form-table td {
  border-right: 1px solid #ebeef5;
  border-bottom: 1px solid #ebeef5;
  padding: 10px;
  min-width: 0;
  box-sizing: border-box;
  text-overflow: ellipsis;
  vertical-align: middle;
  position: relative;
}

.xh-star {
  color: red;
}
</style>